import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
    GET_VENDOR_LOGOUT_REQUEST,
    VENDOR_SESSION_EXPIRED_REQUEST,
} from "./type";
import { getVendorLogoutSuccess } from "./action";
import { ApiResponseMessage } from "../../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../../constant/commonConstants";
import { invokeApi } from "../../../../helper/axiosHelper";
import { removeLoggedInVendorDetails } from "../../../../utils/authUtils";


function* logout() {
    try {
        const res = yield call(invokeApi, "post", "/logout", {}, {}, "vendor");
        if (res.status) {
            ApiResponseMessage(res.message, SUCCESS);
        } else {
            ApiResponseMessage(res.message, DANGER);
        }
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    } finally {
        removeLoggedInVendorDetails();
        yield put(getVendorLogoutSuccess({ status: true }));
    }
}


function* sessionExpired() {
    try {
        yield call(invokeApi, "post", "/sessionExpired", {}, {}, "vendor");
    } catch (error) {
    } finally {
        removeLoggedInVendorDetails();
        yield put(getVendorLogoutSuccess(null));
    }
}

function* watchVendorLogoutRequest() {
    yield takeLatest(GET_VENDOR_LOGOUT_REQUEST, logout);
    yield takeLatest(VENDOR_SESSION_EXPIRED_REQUEST, sessionExpired);
}

function* VendorLogoutSaga() {
    yield all([fork(watchVendorLogoutRequest)]);
}

export default VendorLogoutSaga;
